<template>
  <sliding-wizard
    :startIndex="start"
    :is-read-only="isReadOnly"
    :is-order-complete="isOrderComplete"
    :is-monetary-order="isMonetaryOrder"
    :is-partner-account="isPartnerAccount"
    v-on:tab-change="orderTabChanged"
    v-on:finish-order="finishOrder"
    class="simpleWizardStyle col-md-10 mx-auto"
  >
    <template slot="header">
      <h3 class="card-title"></h3>
    </template>

    <wizard-tab :before-change="() => validateStep('step1Submission')">
      <template slot="label">
        <i class="tim-icons icon-key-25"></i>
        <p style="display: inline-block; width: 50px;" class="medium-font">Submit</p>
       
      </template>
      <submission
        :is-read-only="isReadOnly"
        ref="step1Submission"
        @on-validated="onStepValidated"
      ></submission>
    </wizard-tab>

    <wizard-tab :before-change="() => validateStep('step2Authorization')">
      <template slot="label">
        <i class="tim-icons icon-key-25"></i>
        <p class="medium-font">Authorize</p>
      </template>
      <authorization
        :is-read-only="isReadOnly"
        :tabId="this.currentTab"
        ref="step2Authorization"
        v-on:show-document-tab="showDocumentTab"
        @on-validated="onStepValidated"
      ></authorization>
    </wizard-tab>

    <wizard-tab :before-change="() => validateStep('step3Receipt')">
      <template slot="label">
        <i class="tim-icons icon-paper"></i>
        <p class="medium-font">Receipt</p>
      </template>
      <receipt
        :is-read-only="isReadOnly"
        ref="step3Receipt"
        v-on:show-document-tab="showDocumentTab"
        @on-validated="onStepValidated"
      ></receipt>
    </wizard-tab>

    <wizard-tab :before-change="() => validateStep('step4Replacement')">
      <template slot="label">
        <i class="tim-icons icon-paper"></i>
        <p class="medium-font">Return / Replacement</p>
      </template>
      <replacement
        :is-read-only="isReadOnly"
        ref="step4Replacement"
        v-on:show-document-tab="showDocumentTab"
        @on-validated="onStepValidated"
      ></replacement>
    </wizard-tab>

    <wizard-tab :before-change="() => validateStep('step5Invoice')">
      <template slot="label">
        <i class="tim-icons icon-single-copy-04"></i>
        <p class="medium-font">Invoice</p>
      </template>
      <invoice
        :is-read-only="isReadOnly"
        ref="step5Invoice"
        v-on:show-document-tab="showDocumentTab"
        @on-validated="onStepValidated"
      ></invoice>
    </wizard-tab>

    <wizard-tab :before-change="() => validateStep('step6Bill')">
      <template slot="label">
        <i class="tim-icons icon-money-coins"></i>
        <p class="medium-font">Bill</p>
      </template>
      <bill
        :is-read-only="isReadOnly"
        ref="step6Bill"
        v-on:show-document-tab="showDocumentTab"
        @on-validated="onStepValidated"
      ></bill>
    </wizard-tab>

    <wizard-tab :before-change="() => validateStep('step7Completion')">
      <template slot="label">
        <i class="tim-icons icon-shape-star"></i>
        <p class="medium-font">Completion</p>
      </template>
      <completion
        :is-read-only="isReadOnly"
        ref="step7Completion"
        v-on:show-document-tab="showDocumentTab"
        :completed-text="completedText"
        @on-validated="onStepValidated"
      ></completion>
    </wizard-tab>
  </sliding-wizard>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Submission from "@/components/App/order/Submission.vue";
import Authorization from "@/components/App/order/Authorization.vue";
import Receipt from "@/components/App/order/Receipt.vue";
import Replacement from "@/components/App/order/Replacement.vue";
import Invoice from "@/components/App/order/Invoice.vue";
import Bill from "@/components/App/order/Bill.vue";
import Completion from "@/components/App/order/Completion.vue";
import { SlidingWizard, WizardTab } from "@/components";
import swal from "sweetalert2";
import Util from "@/util/util";

export default {
  components: {
    Submission,
    Authorization,
    Receipt,
    Replacement,
    Invoice,
    Bill,
    Completion,
    SlidingWizard,
    WizardTab
  },
  props: ["isReadOnly"],
  name: "MyOrder",
  data() {
    return {
      wizardModel: {},
      completedText: "This Order is completed and cannot be modified",
      startTab: [
        { index: 0, name: Util.ORDER_STATUS_DRAFT },
        { index: 1, name: Util.ORDER_STATUS_SUBMITTED },
        { index: 2, name: Util.ORDER_STATUS_AUTHORIZED },
        { index: 3, name: Util.ORDER_STATUS_RECEIVED },
        { index: 4, name: Util.ORDER_STATUS_RETURNED},
        { index: 5, name: Util.ORDER_STATUS_INVOICED },
        { index: 6, name: Util.ORDER_STATUS_BILLED },
        { index: 7, name: Util.ORDER_STATUS_COMPLETED }
      ],
      currentTab: 0,
    };
  },
  computed: {
    ...mapGetters({
      orderMetadata: "orderMetadata/orderMetadata",
      orderStatus: "orderMetadata/orderStatus",
      authorizedAcceptor: "authorizedAcceptor/authorizedAcceptor", // Authorize Tab
      authorizedRequestor: "authorizedRequestor/authorizedRequestor", // Authorize Tab
      inspectedReceivedBy: "inspectedReceivedBy/inspectedReceivedBy", // Receipt Tab
      returnReplacementAcknowledgment:
        "returnReplacementReceiptAcknowledgment/returnReplacementReceiptAcknowledgment",
      supplyOfficial: "supplyOfficial/supplyOfficial", // Invoice Tab
      financialRepresentative:  "financialRepresentative/financialRepresentative", // Bill Tab
      preOrder: "preOrderDetail/preOrder",
      isMonetaryOrder: "preOrderDetail/isMonetaryOrder",
      documents: "documents/getDocuments",
       disbursingCollectionInformationStatus:
        "disbursingCollectionInformation/disbursingCollectionInformationStatus",
      isPartnerAccount: "authentication/isPartnerAccount",
      
      reloadStates: "moduleState/getAllStates"
    }),
    canOrderComplete() {
      return this.isMonetaryOrder
        ? (!this.inspectedReceivedBy.isPartial || Util.isLegacyOrder(this.orderMetadata.createDate))
        : (Util.isLegacyOrder(this.orderMetadata.createDate) || (!this.inspectedReceivedBy.isPartial));
    },
    isOrderComplete() {
      return this.orderStatus == Util.ORDER_STATUS_COMPLETED ? true : false;
    },
    orderIdFromRoute() {
      return parseInt(this.$route.params.id);
    },
    start() {
      let ctx = this;
      let tab = ctx.startTab.find((item) => item.name === ctx.orderStatus);
      if (tab.index > 0) {
          this.currentTab = tab.index;
          return tab.index;
      } else {
        this.currentTab = tab.index || 0;
        return tab.index || 0;
      }
    },
    orderId() {
      if (this.isOrderIdAvailable && this.orderIdFromRoute !== 0) {
        return this.orderIdFromRoute;
      } else {
        return this.orderIdFromPreOrderDetail.orderId;
      }
    },
    isOrderIdAvailable() {
      return (
        this.orderIdFromRoute != 0 ||
        (this.orderIdFromRoute != 0 &&
          this.orderIdFromPreOrderDetail &&
          this.orderIdFromPreOrderDetail.orderId != 0)
      );
    },
    formButtonText() {
      return this.isReadOnly ? "Next" : "Submit";
    },
    isAuthorizationSignatureUploaded() {
      let isDocumentUploaded =
        this.documents.filter((document) =>
          document.fileTypeNames.includes("TRANSACTION AUTHORIZATION")
        ).length > 0
          ? true
          : false;

      return isDocumentUploaded ||
        (this.authorizedAcceptor.acceptorSignature &&
          this.authorizedRequestor.requestorSignature)
        ? true
        : false;
    },
    isInspectedReceviedByUploaded() {
      let isDocumentUploaded =
        this.documents.filter((document) =>
          document.fileTypeNames.includes("RECEIVING REPORT")
        ).length > 0
          ? true
          : false;

      return isDocumentUploaded || this.inspectedReceivedBy.receiverSignature
        ? true
        : false;
    },
    isSupplyOfficialSignatureUploaded() {
      let isDocumentUploaded =
        this.documents.filter((document) =>
          document.fileTypeNames.includes("INVOICED")
        ).length > 0
          ? true
          : false;

      return isDocumentUploaded || this.supplyOfficial.supplierSignature
        ? true
        : false;
    },
    isFinancialRepresentativeSignatureUploaded() {
      let isDocumentUploaded =
        this.documents.filter((document) =>
          document.fileTypeNames.includes("BILL")
        ).length > 0
          ? true
          : false;

      return isDocumentUploaded ||
        this.financialRepresentative.financeSignature
        ? true
        : false;
    },
    isSignatureProcessCompleted() {
      // Bypass front end signature/documents checking if order is a legacy order (older than 2/20/2021)
      try {
        if (Util.isLegacyOrder(this.orderMetadata.createDate)) {
          return true;
        }
      } catch {
        return true; // I don't know if we allowed string dates in legacy.  I'm allowing them to bypass this otherwise they can't complete their legacy orders.
      }

      // Check if Order is monetary type
      if (this.isMonetaryOrder) {
        if (
          this.isAuthorizationSignatureUploaded &&
          this.isInspectedReceviedByUploaded &&
          this.isSupplyOfficialSignatureUploaded &&
          this.isFinancialRepresentativeSignatureUploaded
        ) {
          return true;
        } else {
          // Show an Alert (Order cannot be completed)
          return false;
        }
      } else {
        // EVE/RIK Order
        if (
          this.isAuthorizationSignatureUploaded &&
          this.isInspectedReceviedByUploaded
        ) {
          return true;
        } else {
          // Show an Alert (Order cannot be completed)
          return false;
        }
      }
    },
  },
  methods: {
    ...mapActions({
      submitCompleted: "orderMetadata/submitCompleted",
      getAuthorizedAcceptor: "authorizedAcceptor/getAuthorizedAcceptor",
      getAuthorizedRequestor: "authorizedRequestor/getAuthorizedRequestor",
      loadReturnReplacementAcknowledgment:
        "returnReplacementReceiptAcknowledgment/getReturnReplacementReceiptAcknowledgment",
      getInspectedReceivedBy: "inspectedReceivedBy/getInspectedReceivedBy",
      loadSupplyOfficial: "supplyOfficial/getSupplyOfficial",
      loadFinancialRepresentative: "financialRepresentative/getFinancialRepresentative",
      getPreOrder: "preOrderDetail/getPreOrder",
      getDocuments: "documents/getDocuments",
      getOrderMetadata: "orderMetadata/getOrderMetadata",
      getDisbursingCollectionInformationStatus:
        "disbursingCollectionInformation/getDisbursingCollectionInformationStatus",
              getDisbursingCollectionOutstandingBalance:
        "disbursingCollectionInformation/getDisbursingCollectionOutstandingBalance",
      setSingleState: "moduleState/setSingleState"
    }),
    validateStep(ref) {
      if (this.isReadOnly) {
        return true;
      } else {
        return this.$refs[ref].validate();
      }
    },
    showDocumentTab() {
      this.$emit("show-document-tab");
    },
    orderTabChanged(oldtab, newTab) {
      this.currentTab = parseInt(newTab.tabId);

      // different phase, we set that reload to be true, and reset other phases
      switch(parseInt(newTab.tabId)) {
        case 0:
          this.setSingleState({ name: 'submission', value: true });
          this.reset('submission');
          break;
        case 1:
          this.setSingleState({ name: 'authorized', value: true });
          this.reset('authorized');
          break;
        case 2:
          this.setSingleState({ name: 'receipt', value: true });
          this.reset('receipt');
         this.getDisbursingCollectionOutstandingBalance(this.$route.params.id)
          break;
        case 3:
          this.setSingleState({ name: 'replacement', value: true });
          this.reset('replacement');
          break;
        case 4:
          this.setSingleState({ name: 'invoice', value: true });
          this.reset('invoice');
          break;
        case 5:
          this.setSingleState({ name: 'bill', value: true });
          this.reset('bill');
          break;
        case 6:
          this.setSingleState({ name: 'complete', value: true });
          this.reset('complete');
          break;
        default:
          break;
      }
    },

    // reseting other phases except for the current one for reloading
    reset(currentTab) {
      for(const tab in this.reloadStates) {
        if(currentTab !== tab) {
          this.setSingleState({ name: tab, value: false });
        }
      }
    },
    onStepValidated(validated, model) {
      this.wizardModel = {
        ...this.wizardModel,
        ...model,
      };
    },
    finishOrder(status) {
      var ctx = this;
      if(!this.disbursingCollectionInformationStatus) {
         new swal({
          title: "Cannot complete order",
          text: `Cannot complete order: Please complete Transaction Completion Module.`,
          icon: "error",
          showCancelButton: false,
          confirmButtonColor: "#10b45a",
          cancelButtonColor: "red",
          confirmButtonText: "Close",
        });
        return;
      }
      if (!this.isSignatureProcessCompleted) {
        new swal({
          title: "Cannot complete order",
          text: `Supporting Documents/Signature Verification is pending. Please complete it before completing order.`,
          icon: "error",
          showCancelButton: false,
          confirmButtonColor: "#10b45a",
          cancelButtonColor: "red",
          confirmButtonText: "Close",
        });
        return;
      }

      if (!this.canOrderComplete) {
        new swal({
          title: "Cannot complete order",
          text: `Cannot complete partial orders, please check receipt phase and update your order.`,
          icon: "error",
          showCancelButton: false,
          confirmButtonColor: "#10b45a",
          cancelButtonColor: "red",
          confirmButtonText: "Close",
        });
        return;
      }

      new swal({
        title: "Are you sure?",
        text: `Complete this Order?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#10b45a",
        cancelButtonColor: "red",
        confirmButtonText: "Yes, complete it!",
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
              ctx.submitCompleted(ctx.orderId).then((res) => {
                if(res.data && res.data.length > 0) {
                  res.data.forEach(error => ctx.$toast.error(error))     
                } else {
                  new swal({
                    title: "Completed!",
                    text: "Order completed and status has been updated. Redirecting to dashboard.",
                    icon: "success",
                    confirmButtonColor: "#10b45a",
                  });
  
                  ctx.$router.push({ name: "Dashboard" });
                }
              })
            .catch((error) => {
              var text = "";

              if (Array.isArray(error.response.data)) {
                var arr = error.response.data.map(
                  (err) => `<br><br> ${err.errorMessage}`
                );
                text = arr.join(" ");
              } else {
                text = error.response.data;
              }

              new swal({
                title: "Error",
                html: `<h3>Order cannot be completed. See the following errors:</h3> <h4 style="color:red">${text}</h4>`,
                icon: "error",
                confirmButtonColor: "red",
              });
            });
        }
      });
    },
    wizardComplete() {
      //console.log("Good job! You clicked the finish button!"); //not handelled
    },
    loadSignatureData() {
      this.getAuthorizedAcceptor(this.orderIdFromRoute); // Authorize Tab
      this.getAuthorizedRequestor(this.orderIdFromRoute); // Authorize Tab
      this.loadReturnReplacementAcknowledgment(this.orderIdFromRoute); // Receipt Tab
      this.getInspectedReceivedBy(this.orderIdFromRoute); // Receipt Tab
      this.loadSupplyOfficial(this.orderIdFromRoute); // Invoice Tab
      this.loadFinancialRepresentative(this.orderIdFromRoute); // Bill Tab
      this.getPreOrder(this.orderIdFromRoute);
      this.getDocuments(this.orderIdFromRoute);
    },
  },
  created() {
    this.getAuthorizedAcceptor(this.orderIdFromRoute); // Authorize Tab
    this.getAuthorizedRequestor(this.orderIdFromRoute); // Authorize Tab
    this.loadReturnReplacementAcknowledgment(this.orderIdFromRoute);
    this.getInspectedReceivedBy(this.orderIdFromRoute); // Receipt Tab
    this.loadSupplyOfficial(this.orderIdFromRoute); // Invoice Tab
    this.loadFinancialRepresentative(this.orderIdFromRoute); // Bill Tab
    this.getPreOrder(this.orderIdFromRoute);
    this.getDocuments(this.orderIdFromRoute);
    this.getOrderMetadata(this.orderIdFromRoute);
  }
};
</script>

<style scoped>
.simpleWizardStyle {
  padding-left: 0px;
  padding-right: 0px;
  margin-left: 0px;
  margin-right: 0px;
}

.card .card-header {
  padding: 0px;
  margin: 0px;
}
</style>
